import React, { useState, useCallback, useContext } from "react"
import { toast } from "react-toastify"

import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"
import { Button, useMediaQuery, useTheme } from "@material-ui/core"
import { AuthContext } from "../../../context/Auth/AuthContext"
import ConfirmationModal from "../../../components/ConfirmationModal"
import QrcodeModal from "../../../components/QrcodeModal"
import WhatsAppModal from "../../../components/WhatsAppModal"
import { Can } from "../../../components/Can"
import DefaultButton from "../../../components/DefaultButton"
import { Plus } from "lucide-react"
import api from "../../../services/api"
import toastError from "../../../errors/toastError"
import useStyles from "../../styles"

const ConnectionsLayout = () => {
  const classes = useStyles()
  const theme = useTheme()
  const lMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const { user } = useContext(AuthContext)
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false)
  const [qrModalOpen, setQrModalOpen] = useState(false)
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null)
  const [confirmModalOpen, setConfirmModalOpen] = useState(false)
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  }
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState)

  const handleOpenWhatsAppModal = () => {
    setSelectedWhatsApp(null)
    setWhatsAppModalOpen(true)
  }

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false)
    setSelectedWhatsApp(null)
  }, [setSelectedWhatsApp, setWhatsAppModalOpen])

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null)
    setQrModalOpen(false)
  }, [setQrModalOpen, setSelectedWhatsApp])

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`)
      } catch (err) {
        toastError(err)
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`)
        toast.success("Conexão com o WhatsApp excluída com sucesso!")
      } catch (err) {
        toastError(err)
      }
    }

    setConfirmModalInfo(confirmationModalInitialState)
  }

  return (
    <>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      <QrcodeModal
        open={qrModalOpen}
        onClose={handleCloseQrModal}
        whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
      />
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
      />

      {!lMobile && (
        <Can
          role={user.profile}
          perform="connections-page:addConnection"
          yes={() => (
            <Button
              variant="contained"
              startIcon={<Plus />}
              color="primary"
              className={classes.buttonNova}
              disableElevation
              onClick={handleOpenWhatsAppModal}
            >
              Nova
            </Button>
          )}
        />
      )}
    </>
  )
}

export default ConnectionsLayout
